namespace $ {

	/** A fresh document and CRDT cache using the same deployed runtime as the parent. */
	export function $shm_hitalama_app_benchmark_boot() {
		const token = new URL($mol_dom_context.location.href).searchParams.get('benchmark_runner')
		if (!token || $mol_dom_context.parent === $mol_dom_context.window) return
		const root = $mol_dom_context.document.querySelector('[mol_view_root="$shm_hitalama_app"]')
		if (!root) return
		// Reload measurements must not keep the previous iframe document alive
		// for the global cross-document transition or reject its skipped animation.
		$mol_style_attach('$shm_hitalama_app_benchmark_boot', '@view-transition { navigation: none; }')
		root.setAttribute('mol_view_root', $shm_hitalama_benchmarks_runner.toString())
	}

	$shm_hitalama_app_benchmark_boot()

}
